import { render, staticRenderFns } from "./StatusClient.vue?vue&type=template&id=58b4b6ce&"
import script from "./StatusClient.vue?vue&type=script&lang=js&"
export * from "./StatusClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports